import React from 'react';

export const UnderConstruct = () => (
	<div className="flex justify-center h-12">
		<div className="self-center text-center">
			🚧 Area is under construction
		</div>
	</div>
);
